<span class="cnae-indicador-badges">
    <sgt-cnae-indicador-principal-badge *ngIf="principal"></sgt-cnae-indicador-principal-badge>
    <sgt-cnae-indicador-secundaria-badge *ngIf="secundaria"></sgt-cnae-indicador-secundaria-badge>
</span>